import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder

//工单列表查询
export function postWorkTransferList(data) {
    return request({
        url: serviceName + `/transfer/page`,
        method: 'post',
        data: data
    })
}

//接收转单
export function postWorkTransferAccept(data) {
    return request({
        url: serviceName + `/transfer/receive`,
        method: 'post',
        data: data
    })
}